const LocalStorage = (function() {
  let service;
  function getService() {
    if (!service) {
      service = this;
      return service;
    }
    return service;
  }

  function setValue(key, value) {
    localStorage.setItem(key, value);
  }

  function getValue(key) {
    return localStorage.getItem(key);
  }

  function clearValue(key) {
    localStorage.removeItem(key);
  }

  function getUid() {
    const uid = service.getValue("uid") || Math.random().toString(36);

    if (!service.getValue("uid")) {
      service.setValue("uid", uid);
    }

    return uid;
  }

  return {
    getService,
    setValue,
    getValue,
    clearValue,
    getUid
  };
})();

export default LocalStorage;
